export default __webpack_public_path__ + "static/media/namespaces.8ac40c13.svg";